import { ContactEntity } from '../contact';
import { Entity, EntityLink } from '../entity';
import { EquipmentEntity } from './equipment';
import { StockLocationEntity } from './stock.location';

export enum StockMovementType {
    IN = 'IN',
    OUT = 'OUT',
    TRANSFER = 'TRANSFER',
}

export enum StockMovementStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
}

export interface EquipmentInstallRequest {
    equipmentId: string;
    jobId: string;
}

export interface EquipmentUninstallRequest {
    equipmentId: string;
    jobId: string;
}

export interface EquipmentMovementRequest {
    equipmentId: string;
    type: StockMovementType;
    fromLocation?: StockLocationEntity;
    toLocation?: StockLocationEntity;
    quantity?: number;
    serialNumber?: string;
    reference: string;
    links: EntityLink[];
}

export interface EquipmentMovement extends Entity {
    _id: string;
    date: Date;
    type: StockMovementType;
    status: StockMovementStatus;
    equipment: EquipmentEntity;
    fromLocation?: StockLocationEntity;
    toLocation?: StockLocationEntity;
    quantity?: number;
    serialNumber?: string;
    reference: string;
    user: ContactEntity;
    links: EntityLink[];
}

export function getEquipmentMovementLockId(request: EquipmentMovementRequest): string {
    const lockId = [request.equipmentId, request?.serialNumber].map(x => x?.toString()).filter(x => !!x).join(':');
    return lockId;
}